__turbopack_context__.v({
  "dropdown_btn": "LWl4YG_dropdown_btn",
  "same_country_modal": "LWl4YG_same_country_modal",
  "text_content": "LWl4YG_text_content",
});
